/**
 * <kik-product-certification>
 *
 * Client-side filtering for the KIK Product Certification table. The LOT and
 * Manufactured Date <select> dropdowns (marked `data-filter="lot" | "date"`)
 * filter the certificate rows (each carrying `data-lot` / `data-date`). Filters
 * combine with AND; an empty value ("All") matches every row.
 *
 * Progressive enhancement: with JS off, no row is hidden — the full table shows.
 */
class KikProductCertification extends HTMLElement {
  connectedCallback() {
    this.selects = Array.from(this.querySelectorAll('[data-filter]'));
    this.rows = Array.from(this.querySelectorAll('tbody [data-lot], tbody [data-date]'));
    this.emptyRow = this.querySelector('[data-empty]');

    if (!this.selects.length || !this.rows.length) return;

    this.onChange = this.apply.bind(this);
    this.selects.forEach((select) => select.addEventListener('change', this.onChange));
    this.apply();
  }

  disconnectedCallback() {
    this.selects?.forEach((select) => select.removeEventListener('change', this.onChange));
  }

  apply() {
    const active = {};
    this.selects.forEach((select) => {
      active[select.dataset.filter] = select.value;
    });

    let visible = 0;
    this.rows.forEach((row) => {
      const okLot = !active.lot || row.dataset.lot === active.lot;
      const okDate = !active.date || row.dataset.date === active.date;
      const show = okLot && okDate;
      row.hidden = !show;
      if (show) visible += 1;
    });

    if (this.emptyRow) this.emptyRow.hidden = visible !== 0;
  }
}

if (!customElements.get('kik-product-certification')) {
  customElements.define('kik-product-certification', KikProductCertification);
}
